/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.travel_title }}</li>
    <li class="w-50 list-item-col">
      <label>{{Itemize.date_in | formatTimestamp}} / {{Itemize.date_out | formatTimestamp}}</label>
      <!-- <label v-else>{{Itemize.date_in | formatTimestamp}}</label> -->
    </li>
    <li class="w-50 list-item-col">{{Itemize.num}} 人</li>
    <li class="w-50 list-item-col">{{Itemize.order_type | formatVar('OrderType')}} ({{Itemize.team_type==2?'会议团':'旅游团'}})</li>
    <li class="w-50 list-item-col">{{Itemize.deal_time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col" :class="[$GFUN.FormatColor(Itemize.status)]">{{Itemize.status | formatVar('TOrderStatus')}}</li>
    <!-- <li class="w-50 list-item-col">
      <span class="text-link" @click="$router.push({name:'OrderDetail',query:{orderType:Itemize.order_type,orderId:Itemize.id}})">查看详情</span>
    </li> -->
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeAdmin',
    props:{
      Itemize:{}
    },
    computed:{
      orderStatus() {
        switch (Number(this.Itemize.order_type)) {
          case 3:
          case 5: return 'TOrderStatus';
          case 6: return 'SOrderStatus';
          case 8: return 'TBOrderStatus';
          default:return ''
        }
      }
    }
  }
</script>
